import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useState } from 'react';
import { Outside } from '@cian/ui-kit';
import { SupportContactsWidgetOpenButton, SupportContactsWidgetPopup, SupportContactsWidgetRootWrapper } from './components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SupportContactsWidget = function SupportContactsWidget(props) {
  var contactsPosition = props.contactsPosition,
    onClose = props.onClose,
    onOpen = props.onOpen,
    heading = props.heading,
    description = props.description,
    theme = props.theme,
    children = props.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var openButtonRef = useRef(null);
  var handleTogglePopup = function handleTogglePopup() {
    if (isOpen) {
      onClose === null || onClose === void 0 ? void 0 : onClose();
      setIsOpen(false);
    } else {
      onOpen === null || onOpen === void 0 ? void 0 : onOpen();
      setIsOpen(true);
    }
  };
  var handleClosePopup = function handleClosePopup() {
    onClose === null || onClose === void 0 ? void 0 : onClose();
    setIsOpen(false);
  };
  return /*#__PURE__*/_jsxs(SupportContactsWidgetRootWrapper, {
    contactsPosition: contactsPosition,
    children: [/*#__PURE__*/_jsx(SupportContactsWidgetOpenButton, {
      onClick: handleTogglePopup,
      ref: openButtonRef
    }), isOpen && /*#__PURE__*/_jsx(Outside, {
      onOutside: handleClosePopup,
      insideRefs: [openButtonRef],
      children: /*#__PURE__*/_jsx(SupportContactsWidgetPopup, {
        theme: theme,
        heading: heading,
        description: description,
        onClose: handleClosePopup,
        children: children
      })
    })]
  });
};